module.exports = __webpack_public_path__ + "img/chart_sort_top.f7794019.svg";